



























































































































































































































import {Component, Vue} from 'vue-property-decorator';
import {CourseCatalog} from '@/static/course';
import {CourseRouterPath} from '@/router/official';

@Component
export default class CourseCatalogView extends Vue {
  private courseCatalog: any = CourseCatalog;


  public onCourseDetail(course: string) {
    this.$router.push({name: CourseRouterPath.OFFICIAL_COURSE_DETAIL_VIEW, params: {courseId: course}});
  }

  get catalogData(): any {
    let courseId = this.$route.params.id;
    return this.courseCatalog[courseId];
  }


}
